/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button } from "../../../../../components/Component";
import Swal from "sweetalert2";
const ERDataUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        activeStatus:"O",
        employmentId: 0,
        employmentRefId: 0
    });


    const getdata = async () => {      
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            MonthId: Number(props.month),
            EmploymentRefIdEr: props.parent,
            YearId: Number(props.year),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK+'api/ER/Dashdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   
                    //console.log(data)
                    if (data !== "No data") {
                        setFormData({
                            ...formData,
                            activeStatus: data.activeStatus,
                            employmentId: data.employmentIdEr,
                            employmentRefId: data.employmentRefIdEr
                        });
                      
                    } else {
                        setFormData({
                            ...formData,
                            activeStatus: "O",
                            employmentId: data.employmentIdEr,
                            employmentRefId: data.employmentRefIdEr
                        });
                    }
                   
                    setload(false)
                })


    };

    

    

    const check = async () => {

        const sendData = {
            EmploymentRefIdEr: Number(props.parent),
            UserId: Number(localStorage.getItem("userId")),
            YearId: Number(props.year),
            MonthId: Number(props.month)
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK+'api/ER/Checkdraft2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data === "NO") {
                        window.location.pathname = props.path

                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: data.month.catgDesc + " " + data.yearId ,
                            text: data.month.catgDesc+" " + data.yearId + " Data of " + data.table.name+ " is Already in Draft",
                            focusConfirm: false,
                        });
                    }

                })


    };
    const Editpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = props.path + "-Edit"

    };
    const viewpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = props.path + "-View"

                  



    };





    useEffect(() => {
        if (Number(props.year) > 0 && Number(props.month) > 0) {
            getdata()
        }
 

    }, [props.year, props.month])




    return (
        load ? null : <>
            
                <tr className="tb-odr-item" >

                    <td  >
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.sno}</b>
                        </a>
                    </td>
                    <td  >
                        <a
                            href="#id"
                            onClick={(ev) => {
                                ev.preventDefault();
                            }}
                        >
                            <b style={{ fontSize: 18 }}>{props.name}</b>
                        </a>
                    </td>
                    <td  >
                        {formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> Open</b></>}
                    </td>
                    <td  >
                        {formData.activeStatus === "A" ? <Button onClick={(ev) => {
                            ev.preventDefault();
                             Editpage()
                        }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                            <b style={{ fontSize: 18 }}> Edit </b>
                        </Button> : formData.activeStatus === "S" ? <Button
                            color="success" onClick={(ev) => {
                                ev.preventDefault();
                                viewpage()
                            }} >
                            <b style={{ fontSize: 18 }}>View</b>
                        </Button> : <Button onClick={(ev) => {
                            ev.preventDefault();
                            check()
                        }} style={{ backgroundColor: "#e85347", color: "white" }} >
                            <b style={{ fontSize: 18 }}> Add </b>
                        </Button>}

                    </td>

                </tr> 
                
        </>
    );
};

export default ERDataUpdate;
